// Rules tab — reuses the existing production chatbot rule builder.
import React from 'react';
import WhatsAppChatbot from '../../whatsapp/WhatsAppChatbot';

const RulesTab = () => <WhatsAppChatbot />;

export default RulesTab;
